import React from 'react'
import styles from "./TransactionsHistory.module.scss"
import { AppleOutlined, CheckCircleOutlined, CloseCircleOutlined, CreditCardOutlined, DollarOutlined, GoogleOutlined, WalletOutlined } from '@ant-design/icons'
import moment from 'moment'
import clsx from 'clsx'
import { MERCHANT } from 'utils/enums'


const TRANSACTIONS_STATUS = {
    Failed: 'Failed',
    Paid: 'Paid'
}

const MERCHANT_ICON = {
    [MERCHANT.Cash]: DollarOutlined,
    [MERCHANT.Stripe]: CreditCardOutlined,
    [MERCHANT.Wallet]: WalletOutlined,
    [MERCHANT.ApplePay]: AppleOutlined,
    [MERCHANT.GooglePay]: GoogleOutlined
}


const MERCHANT_TEXT = {
    [MERCHANT.Cash]: "Cash Payment",
    [MERCHANT.Wallet]: "Wallet Payment"
}


export default function TransasctionHistoryItem({ transactionHistory
}) {


    const { status, amount, last4, merchant, paymentDate, paymentId, brand } = transactionHistory

    const utc = moment.utc(paymentDate);
    const cst = utc.tz("America/Chicago");
    const IconComponent = MERCHANT_ICON[merchant]
    return (
        <div className={styles.itemContainer}>
            <div className={styles.left}>
                <div>
                    {
                        status === TRANSACTIONS_STATUS.Paid
                            ? <CheckCircleOutlined className={[styles.icon, styles.checkmark]} /> :
                            <CloseCircleOutlined className={[styles.icon, styles.crossmark]} />
                    }

                </div>
                {IconComponent && <IconComponent className={styles.cardIcon} />}

                <div>
                    <div className={styles.cardBrand}> {brand ?? MERCHANT_TEXT[merchant]} {last4 ? `*${last4}` : ""}</div>
                    <div className={styles.cardExpiry}> {cst.format("MMMM, DD YYYY - h:mm a")} (CST)</div>
                </div>
            </div>
            <div className={styles.right}>
                <div className={clsx([styles.amountTag, status === TRANSACTIONS_STATUS.Failed && styles.failedTag])}>
                    ${Number(amount ?? 0).toFixed(2)}
                </div>
            </div>
        </div>
    )
}
